export const footerMoreLinks = {
  'iq-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://iq.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://iq.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://iq.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://iq.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://iq.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://iq.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'iq-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://iq.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://iq.wingie.com/en/faq/',
          title: 'FAQ',
        },
        {
          href: 'https://iq.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://iq.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://iq.wingie.com/en/terms-and-conditions/',
          title: 'Terms and conditions',
        },
        {
          href: 'https://iq.wingie.com/en/awards/',
          title: 'Our awards',
        },
      ],
    },
  ],
  'iq-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://iq.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://iq.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://iq.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://iq.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://iq.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://iq.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'iq-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://iq.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://iq.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },
        {
          href: 'https://iq.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://iq.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://iq.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://iq.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'iq-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://iq.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://iq.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas frecuentes',
        },
        {
          href: 'https://iq.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://iq.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://iq.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones',
        },
        {
          href: 'https://iq.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'iq-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://iq.wingie.com/it/contact/',
          title: 'Contatto',
        },
        {
          href: 'https://iq.wingie.com/it/faq/',
          title: 'Domande frequenti',
        },
        {
          href: 'https://iq.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://iq.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://iq.wingie.com/it/terms-and-conditions/',
          title: 'Termini e condizioni',
        },
        {
          href: 'https://iq.wingie.com/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'iq-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://iq.wingie.com/fr/contact/',
          title: 'Contact',
        },
        {
          href: 'https://iq.wingie.com/fr/faq/',
          title: 'Questions fréquentes',
        },
        {
          href: 'https://iq.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://iq.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://iq.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et conditions',
        },
        {
          href: 'https://iq.wingie.com/fr/awards/',
          title: 'Nos récompenses',
        },
      ],
    },
  ],
  'iq-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://iq.wingie.com/pt/contact/',
          title: 'Contato',
        },
        {
          href: 'https://iq.wingie.com/pt/faq/',
          title: 'Perguntas frequentes',
        },
        {
          href: 'https://iq.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://iq.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://iq.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e condições',
        },
        {
          href: 'https://iq.wingie.com/pt/awards/',
          title: 'Nossos prêmios',
        },
      ],
    },
  ],
  'iq-ro': [
    {
      title: 'Mai multe',
      items: [
        {
          href: 'https://iq.wingie.com/ro/contact/',
          title: 'Contact',
        },
        {
          href: 'https://iq.wingie.com/ro/faq/',
          title: 'Întrebări frecvente',
        },
        {
          href: 'https://iq.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://iq.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://iq.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și condiții',
        },
        {
          href: 'https://iq.wingie.com/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'iq-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://iq.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        {
          href: 'https://iq.wingie.com/pl/faq/',
          title: 'Często zadawane pytania',
        },
        {
          href: 'https://iq.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://iq.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://iq.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://iq.wingie.com/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'iq-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://iq.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        {
          href: 'https://iq.wingie.com/lt/faq/',
          title: 'Dažnai užduodami klausimai',
        },
        {
          href: 'https://iq.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://iq.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://iq.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir sąlygos',
        },
        {
          href: 'https://iq.wingie.com/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'iq-uz': [
    {
      title: 'Boshqa',
      items: [
        {
          href: 'https://iq.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        {
          href: 'https://iq.wingie.com/uz/faq/',
          title: "Ko'p beriladigan savollar",
        },
        {
          href: 'https://iq.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://iq.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://iq.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va qoidalar',
        },
        {
          href: 'https://iq.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'iq-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://iq.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        {
          href: 'https://iq.wingie.com/sr/faq/',
          title: 'Честа питања',
        },
        {
          href: 'https://iq.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://iq.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://iq.wingie.com/sr/terms-and-conditions/',
          title: 'Услови коришћења',
        },
        {
          href: 'https://iq.wingie.com/sr/awards/',
          title: 'Наше награде',
        },
      ],
    },
  ],
  'iq-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://iq.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        {
          href: 'https://iq.wingie.com/ky/faq/',
          title: 'Көп берилүүчү суроолор',
        },
        {
          href: 'https://iq.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://iq.wingie.com/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://iq.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана эрежелер',
        },
        {
          href: 'https://iq.wingie.com/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'iq-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://iq.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        {
          href: 'https://iq.wingie.com/tg/faq/',
          title: 'Саволҳои зуд-зуд пурсида мешаванда',
        },
        {
          href: 'https://iq.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://iq.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://iq.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва қоидаҳо',
        },
        {
          href: 'https://iq.wingie.com/tg/awards/',
          title: 'Мукофотҳои мо',
        },
      ],
    },
  ],
  'iq-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://iq.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        {
          href: 'https://iq.wingie.com/kk/faq/',
          title: 'Жиі қойылатын сұрақтар',
        },
        {
          href: 'https://iq.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://iq.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://iq.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://iq.wingie.com/kk/awards/',
          title: 'Біздің марапаттар',
        },
      ],
    },
  ],
  'iq-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://iq.wingie.com/nl/contact/',
          title: 'Contact',
        },
        {
          href: 'https://iq.wingie.com/nl/faq/',
          title: 'Veelgestelde vragen',
        },
        {
          href: 'https://iq.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://iq.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://iq.wingie.com/nl/terms-and-conditions/',
          title: 'Algemene voorwaarden',
        },
        {
          href: 'https://iq.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'iq-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://iq.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://iq.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://iq.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://iq.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://iq.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://iq.wingie.com/ja/awards/' },
      ],
    },
  ],
  'iq-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://iq.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://iq.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://iq.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://iq.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://iq.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://iq.wingie.com/zh/awards/' },
      ],
    },
  ],
  'iq-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://iq.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://iq.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://iq.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://iq.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://iq.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://iq.wingie.com/ko/awards/' },
      ],
    },
  ],
  'iq-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://iq.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://iq.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://iq.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://iq.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://iq.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://iq.wingie.com/hi/awards/' },
      ],
    },
  ],
  'iq-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://iq.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://iq.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://iq.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://iq.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://iq.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://iq.wingie.com/ta/awards/' },
      ],
    },
  ],
  'iq-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://iq.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://iq.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://iq.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://iq.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://iq.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://iq.wingie.com/th/awards/' },
      ],
    },
  ],
  'iq-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://iq.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://iq.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://iq.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://iq.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://iq.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://iq.wingie.com/ur/awards/' },
      ],
    },
  ],
  'iq-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://iq.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://iq.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://iq.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://iq.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://iq.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://iq.wingie.com/ka/awards/' },
      ],
    },
  ],
}
